package component.image

import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Image
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import feature.mediaFile.viewModel.MediaFileViewModel
import theme.ThemeColor

@Composable
fun ImageView(
    id: String?,
    viewModel: MediaFileViewModel = MediaFileViewModel()
) {
    val media = viewModel.mediaFile.collectAsState()
    LaunchedEffect(key1 = Unit) {
        if (!id.isNullOrEmpty()) {
            viewModel.loadMedia(id)
        }
    }
    if (!media.value.FileURL.isNullOrEmpty()) {
        AsyncImageView(media.value.FileURL!!)
    } else {
        IconButton(
            onClick = {},
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
        ) {
            Icon(
                Icons.Rounded.Image,
                contentDescription = "decrease quantity",
                modifier = Modifier.height(60.dp).width(60.dp),
                tint = ThemeColor.shared().PrimaryColor,
            )
        }

    }
}